import { getClosestConfigurationFromRow } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import calculateRowLabel from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateRowLabel';
import seatEnumerationValidator from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/SeatEnumerationValidator';

function compileRowLabel(row) {
    if (row.labelLeft.manual || row.labelRight.manual) {
        return row;
    }

    const { rowLabeling } = getClosestConfigurationFromRow(row, 'rowLabeling');
    const { fontConfig } = getClosestConfigurationFromRow(row, 'fontConfig');
    const { spacing } = getClosestConfigurationFromRow(row, 'spacing');
    const { seatConfig } = getClosestConfigurationFromRow(row, 'seatConfig');

    const { labelLeft, labelRight } = calculateRowLabel(
        rowLabeling,
        row.index,
        row.sector.rows.count(),
        row,
        fontConfig,
        spacing,
        seatConfig,
    );

    seatEnumerationValidator.validateRowEnumeration(row, labelLeft, labelRight);

    row.labelLeft = labelLeft;
    row.labelRight = labelRight;

    return row;
}

export default compileRowLabel;
